module.exports = __webpack_public_path__ + "static/Bitmap-94fdc999a55a81ff8533cd43c5176bb5.svg";